class MegaMenuOpener extends HTMLElement {
  constructor() {
    super();

    this.closeTimeout = null;
    this.openTimeout = null;
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("[data-mega-menu-content]");
    this.backgroundEl = document.querySelector("[data-mega-menu-background]");

    this.lastMousePosition = null;

    this.handleMousemove = (e) => {
      this.newMousePosition = {
        y: e.pageY,
        time: Date.now(),
      };

      if (this.lastMousePosition) {
        this.velocity =
          (this.newMousePosition.y - this.lastMousePosition.y) /
          (this.newMousePosition.time - this.lastMousePosition.time);
      }

      this.lastMousePosition = this.newMousePosition;
    };

    document.addEventListener("mousemove", this.handleMousemove);

    this.addEventListener("mouseover", () => {
      if (!isFinite(this.velocity)) return;

      if (Math.abs(this.velocity) > 0.1) {
        if (this.openTimeout) return;

        this.openTimeout = setTimeout(() => {
          this._open();
        }, 100);
      } else {
        this._open();
      }
    });

    this.addEventListener("click", (e) => {
      if (this.summary.contains(e.target) && !e.target.closest("a")) {
        e.preventDefault();
        this.details.open ? this._close() : this._open();
      }
    });

    this.addEventListener("mouseleave", () => {
      this._close();
    });

    this.content.addEventListener("focusout", (e) => {
      if (this.content.contains(e.relatedTarget)) return;

      this._close();
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.details.open) {
        this._close();
        this.summary.focus();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    // With no cross-fade, a menu still in its close delay would sit on top of
    // the newly opened one, so it closes immediately instead.
    this.handleOtherMenuOpen = (e) => {
      if (e.target === this || !this.details.open) return;

      this._close(true);
    };

    document.addEventListener("menu:open", this.handleOtherMenuOpen);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("mousemove", this.handleMousemove);
    document.removeEventListener("menu:open", this.handleOtherMenuOpen);
  }

  _open() {
    clearTimeout(this.closeTimeout);
    clearTimeout(this.openTimeout);
    this.openTimeout = null;
    this.details.open = true;
    this.details.classList.add("open");
    this.backgroundEl.classList.add("active");

    this.backgroundEl.style.setProperty(
      "--active-height",
      `${this.content.getBoundingClientRect().height}px`,
    );
    window.openDimmer(this);
    this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
  }

  _close(force) {
    clearTimeout(this.closeTimeout);
    clearTimeout(this.openTimeout);
    this.openTimeout = null;

    if (force) {
      this._hide();
    } else {
      this.closeTimeout = setTimeout(() => this._hide(), 300);
    }
  }

  _hide() {
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));
    this.details.classList.remove("open");
    this.details.open = false;

    if (!this._allMenusAreClosed()) {
      this.backgroundEl.classList.remove("active");
    }

    window.closeDimmer(this);
  }

  _allMenusAreClosed() {
    return [...document.querySelectorAll(".header__main-nav-mega-menu")].some(
      (el) => el.classList.contains("open"),
    );
  }
}

if (!customElements.get("mega-menu-opener")) {
  customElements.define("mega-menu-opener", MegaMenuOpener);
}
